module.exports = __webpack_public_path__ + "static/media/en.db68882c.svg";